import { getChatRecentEmojisKey, STORAGE_KEY_ALIASES } from '~/app/storageKeys';
import { recentEmojisSchema } from '~/app/storageSchemas';
import { getCurrentStorageUserScopeId } from '~/app/storageScope';
import { safeParseStoredJson } from '~/app/storageValidation';

/** localStorage key alias kept for backward compatibility. */
export const CHAT_RECENT_EMOJIS_STORAGE_KEY = STORAGE_KEY_ALIASES.chatRecentEmojis[0];

const MAX_RECENT = 24;

export function readRecentEmojis(): string[] {
  if (typeof localStorage === 'undefined') return [];
  const canonicalKey = getChatRecentEmojisKey(getCurrentStorageUserScopeId());
  const canonical = safeParseStoredJson(localStorage.getItem(canonicalKey), recentEmojisSchema);
  if (canonical.ok) return canonical.data;
  if (canonical.reason !== 'missing') localStorage.removeItem(canonicalKey);

  // Legacy fallback: migrate old unscoped key into canonical account-scoped key.
  // TODO: [storage-migration-cleanup] Remove legacy fallback after migration window.
  for (const legacyKey of STORAGE_KEY_ALIASES.chatRecentEmojis) {
    const legacy = safeParseStoredJson(localStorage.getItem(legacyKey), recentEmojisSchema);
    if (legacy.ok) {
      localStorage.setItem(canonicalKey, JSON.stringify(legacy.data));
      return legacy.data;
    }
    if (legacy.reason !== 'missing') localStorage.removeItem(legacyKey);
  }
  return [];
}

export function addRecentEmoji(emoji: string): void {
  if (typeof localStorage === 'undefined' || !emoji) return;
  const prev = readRecentEmojis();
  const next = [emoji, ...prev.filter((e) => e !== emoji)].slice(0, MAX_RECENT);
  try {
    const canonicalKey = getChatRecentEmojisKey(getCurrentStorageUserScopeId());
    localStorage.setItem(canonicalKey, JSON.stringify(next));
  } catch {
    /* quota or private mode */
  }
}
